export class QuizEnvelop {
    questions=[]
    datecreated=""
    question_count=0
    level_name=""
    studentName=""
    subjectName=""
    isCompleted=false
    server_quiz_envelop_id=0
    server_user_id=0
    score=0
}
